// ===========
// Collections
$(document).ready(function () {         
    $('.repository-panel a.see-more').click(function (e) {
        $('.mobile-summary .header-summary').toggleClass('shown');
        $(this).hide();
        e.preventDefault(); 
    }); 

    //deselects All when a filter is selected
    $('.topic-filters .ContentCheckBoxList div.tr div.td input').not(':first').each(function (e) {
        $(this).click(function () {
            $('.topic-filters .ContentCheckBoxList div.tr div.td:first input').prop('checked', false);
        });
    });

    //unselects all items when all is checked
    $('.topic-filters .ContentCheckBoxList div.tr div.td input').first().each(function (e) {
        $(this).click(function () {
            if ($(this).is(':checked')) {
                $('.topic-filters .ContentCheckBoxList div.tr div.td input').not(':first').prop('checked', false);
            }
        });
    });

    //Track filter expand state for case when it is not expanded by default
    $('.filter-topics').click(function (e) {
        if ($(this).hasClass('active')) {
            sessionStorage.setItem('topicsAreExpanded', 'true');
        } else {
            sessionStorage.setItem('topicsAreExpanded', 'false');
        }
    });

    var isExpanded = sessionStorage.getItem('topicsAreExpanded');
    if (isExpanded !== 'undefined' && isExpanded === 'true') {
        $('.filter-topics').addClass('active');
        $('.filter-topics').next('.accordion-content').addClass('active');
    }

    $('.filter-language').click(function (e) {
        if ($(this).hasClass('active')) {
            sessionStorage.setItem('languageAreExpanded', 'true');
        } else {
            sessionStorage.setItem('languageAreExpanded', 'false');
        }
    });

    var isExpandedLanguage = sessionStorage.getItem('languageAreExpanded');
    if (isExpandedLanguage !== 'undefined' && isExpandedLanguage === 'true') {
        $('.filter-language').addClass('active');
        $('.filter-language').next('.accordion-content').addClass('active');
    }

    $('.category-filters input, .topic-filters input, .type-filters input, .language-filters input').click(function (e) {        
        updateCollectionFilters();
    });
        
    $('#header-results-count').text($('.pager-container .pager-result-total').first().text());
        
    $('.repository-panel .filter-btn').focus(function () {
        $(this).keydown(function (e) {
            if (e.keyCode == 32) {
                toggleMobileFilterMenu();
                e.preventDefault();
            }
        });
    });
    $('.repository-panel .filter-btn').click(function (e) {
        toggleMobileFilterMenu();
    });

    loadCollectionFilters();
    updateBadges();
});

function toggleMobileFilterMenu() {       
    $('.repository-panel .filter-btn').toggleClass('open'); 
    $('.repository-left-nav').slideToggle();
}

function collectionGetParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function loadCollectionFilters() {
    var queries = {};
    $.each(document.location.search.substr(1).split('&'), function (c, q) {
        var i = q.split('=');
        if (i.length > 1) {
            queries[i[0].toString()] = i[1].toString();
        }
    });

    if (queries['type']) {
        var type = queries['type'];
        $('.type-filters input').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, type) !== -1) {
                    $(this).prop('checked', true);
                }
            }
        });
    } else {
        $('.type-filters input').each(function (index) {
            $(this).prop('checked', false);
        });
        $('.type-filters input').first().prop('checked', true);
    }

    if (queries['cats']) {
        var category = queries['cats'].split(',');
        $('.category-filters input').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, category) !== -1) {
                    $(this).prop('checked', true);
                }
            }
        });
    } else {
        $('.category-filters input').each(function (index) {
            $(this).prop('checked', false);
        });
        $('.category-filters input').first().prop('checked', true);
    }

    if (queries['topics']) {
        queries['topics'] = queries['topics'].replace(/%2c/g, ",");
        var topics = queries['topics'].split(',');
        $('.topic-filters input').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, topics) !== -1) {
                    $(this).prop('checked', true);
                }
            }
        });
    } else {
        $('.topic-filters input').each(function (index) {
            $(this).prop('checked', false);
        });
        $('.topic-filters input').first().prop('checked', true);
    }

    if (queries['translationlanguageids']) {
        queries['translationlanguageids'] = queries['translationlanguageids'].replace(/%2c/g, ",");
        var language = queries['translationlanguageids'].split(',');
        $('.language-filters input').each(function (index) {
            $(this).prop('checked', false);
            var value = $(this).val().match(/\d+/g);
            if (value && value.length > 0) {
                value = value[0];
                if ($.inArray(value, language) !== -1) {
                    $(this).prop('checked', true);
                }
            }
        });
    } else {
        $('.language-filters input').each(function (index) {
            $(this).prop('checked', false);
        });
        $('.language-filters input').first().prop('checked', true);
    }

}

function updateBadges() {    
    $('#filter-badge-container').empty(); 

    $('.category-filters input:checked').each(function () {
        if ($(this).attr('value')) {
            var badgeContent = $('label[for=' + $(this).attr('id') + ']').text();
            var badgeType = 'category';
            var filterInput = '.category-filters input';            
            createRadioBadge(filterInput, badgeType, badgeContent);
        }
    });

    $('.topic-filters input:checked').each(function () {
        //'All' options don't contain a value         
        if ($(this).attr('value')) {
            var tmpId = $(this).attr('id'); 
            var badgeContent = $('label[for=' + tmpId + ']').text();
            var badgeType = 'topic';            
            createCheckboxBadge(tmpId, badgeType, badgeContent);
        }
    });

    $('.type-filters input:checked').each(function () {
        //'All' options don't contain a value 
        if ($(this).attr('value')) {
            var badgeContent = $('label[for=' + $(this).attr('id') + ']').text();
            var badgeType = 'type';
            var filterInput = '.type-filters input';            
            createRadioBadge(filterInput, badgeType, badgeContent);
        }
    });

    $('.language-filters input:checked').each(function () {
        if ($(this).attr('value')) {
            var badgeContent = $('label[for=' + $(this).attr('id') + ']').text();
            var badgeType = 'language';
            var filterInput = '.language-filters input';            
            createRadioBadge(filterInput, badgeType, badgeContent);
        }
    });

    if ($('#filter-badge-container .badge').length > 0) {
        $('#filter-badge-container').prepend('<span>Active Filters: </span>');         
    }
}



function updateCollectionFilters() {
    var topics = 'topics=' + $.grep($('.topic-filters input:checked').map(function () {
        return this.value.match(/\d+/g);
    }).get(), Boolean).join(',');
    var category = 'cats=' + $('.category-filters input:checked').map(function () {
        return this.value.match(/\d+/g);
    }).get();
    var type = 'type=' + $('.type-filters input:checked').map(function () {
        return this.value.match(/\d+/g);
    }).get();
    var language = 'translationlanguageids=' + $('.language-filters input:checked').map(function () {
        return this.value.match(/\d+/g);
    }).get();

    var url = [location.protocol, '//', location.host, location.pathname].join('');

    var searchtext = collectionGetParameterByName('searchtext');
    if (searchtext) {
        searchtext = 'searchtext=' + encodeURIComponent(searchtext);//newly encoded 
    }
    var searchmode = collectionGetParameterByName('searchmode');
    if (searchmode) {
        searchmode = 'searchmode=' + encodeURIComponent(searchmode);
    }

    var query = '';
    query = [type, topics, category, language, searchtext, searchmode].filter(Boolean).join('&');
        
    window.location.href = url + '?' + query; 
}


function createRadioBadge(inputSelect, badgeType, badgeContent) {
    var badge = '<div class="badge ' + badgeType + '-badge" tabindex="0" role="button" aria-pressed="false">';
    badge += badgeContent;
    badge += '</div>';

    $('#filter-badge-container').append(
        $(badge).click(function () {
            $(inputSelect).each(function () { $(this).prop('checked', false); });
            $(inputSelect).first().prop('checked', true);
            updateCollectionFilters();                    
        }).keydown(function (evt) {
            if (evt.keyCode == 13 || evt.keyCode == 32) {
                $(inputSelect).each(function () { $(this).prop('checked', false); });
                $(inputSelect).first().prop('checked', true);
                updateCollectionFilters();
            }            
        })
    );
}

function createCheckboxBadge(inputId, badgeType, badgeContent) {
    var badge = '<div class="badge ' + badgeType + '-badge" tabindex="0" role="button" aria-pressed="false">';
    badge += badgeContent;
    badge += '</div>';

    $('#filter-badge-container').append(
        $(badge).click(function () {            
            $('#' + inputId).prop('checked', false);
            updateCollectionFilters();
        }).keydown(function (evt) {
            if (evt.keyCode == 13 || evt.keyCode == 32) {
                $('#' + inputId).prop('checked', false);
                updateCollectionFilters();
            }
        })
    );
}
